import { Switch } from 'components/switch';
import React, { Suspense } from 'react';
import { Details, Styles } from '_modal/signatureModal';
// import allTemplates from './templates';
import { templateList } from 'components/templateLists';

type props = {
  details: Details;
  styles: Styles;
  template: string;
};

export function getTemplate(details: Details, styles: Styles, template: string) {
  return (
    <Suspense fallback={<></>}>
      <Switch switchCase={template}>
        {templateList.map(({ component: Component, value }) => (
          <Component key={value} details={details} styles={styles} value={value} />
        ))}
      </Switch>
    </Suspense>
  );
}

const Template: React.FC<props> = ({ details, styles, template }) => {
  return getTemplate(details, styles, template);
};

export default Template;
